module.exports = __webpack_public_path__ + "img/bg_main04_mask.f0bcc33b.svg";